export default "__VITE_ASSET__CqSelWrT__"